import DeleteIconButton from 'components/common/delete-icon-button';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import {
  CardSection,
  SeparatorHorizontal,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import ActivityAddOnsTable from './add-ons-table';
import GroupDetailTable from './group-detail-table';
import ActivityGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../style';
import { ActivitySaleFormType } from '../form-type';

interface Props {
  parentIndex: number;
  onRemove: () => void;
  fieldLength?: number;
}

export default function GuestCard({
  parentIndex,
  onRemove,
  fieldLength,
}: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { setValue, getValues, trigger } =
    useFormContext<ActivitySaleFormType>();

  const guestName = `activitySales.${parentIndex}.activitySaleGuests` as const;

  const onAfterChange = React.useCallback(
    (checked: boolean) => {
      const guests = getValues(guestName).map((guest, index, arr) => {
        return {
          ...guest,
          activitySaleGuestDetails: arr?.[0]?.activitySaleGuestDetails || [],
        };
      });
      setValue(guestName, guests);
      trigger(guestName);
    },
    [getValues, setValue, trigger, guestName],
  );

  return (
    <CardSection>
      <ScheduleCardHeader>
        <Text variant="HeadingXSmall">
          {t('common:other_sale_detail')} {parentIndex + 1}
        </Text>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="check-box"
            name={`activitySales.${parentIndex}.isGroupedPrice`}
            label={t('ticketSales:grouped_price')}
            onAfterChange={onAfterChange}
            noMargin
          />
          {(fieldLength || 0) > 1 && editable && (
            <>
              <SeparatorHorizontal $margin={16} />
              <DeleteIconButton
                onClick={onRemove}
                rootStyle={{ height: '32px' }}
              />
            </>
          )}
        </div>
      </ScheduleCardHeader>
      <SeparatorVertical $margin={24} />
      <ActivityGuestTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={24} />
      <GroupDetailTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={12} />
      <ActivityAddOnsTable parentIndex={parentIndex} />
    </CardSection>
  );
}
